import en from './languages/english'
import es from './languages/spanish'
import ar from './languages/arabic'
import jp from './languages/japanese'
import pt from './languages/portuguese'
import zh from './languages/chinese'
import ko from './languages/korean'
// import fr from './languages/french'
export default {
	en,
	es,
	ar,
	jp,
	pt,
	zh,
	ko,
	// fr
}
